import { useMemo } from "react";
import { useParams } from "react-router";

import { useFetchInvoiceTagsQuery } from "../services/api/invoiceTagsApi/invoiceTags";

export function useInvoiceTags() {
  const { organisationId } = useParams<{ organisationId?: string }>();

  const result = useFetchInvoiceTagsQuery({ organisationId }, {
    skip: !organisationId,
  });

  const items = result.data?.tags;

  const tags = useMemo(() => (items || []).map(t => t.name), [items]);

  /** Tag name -> hex color (null when no color set) */
  const colorMap: Record<string, string | null> = useMemo(() => {
    return Object.fromEntries((items || []).map(t => [t.name, t.color]));
  }, [items]);

  return {
    ...result,
    tags,
    colorMap,
  };
}
